module.exports = __webpack_public_path__ + "img/scale_1.png?2531ec05c261a76ad47f8a5c7d82ce8d";